import dayjs from 'dayjs';
import i18n from '@/plugins/i18n';

export const calculateRemainingTime = (start: Date, timeLimitSeconds: number, min: number|null = null): number => {
  const endTime: any = dayjs(start).add(timeLimitSeconds, 'second');

  const now: any = dayjs();

  const diffInSeconds: number = dayjs.duration(endTime.diff(now)).asSeconds();
  if (min !== null && diffInSeconds < min) {
    return min;
  }

  return Math.round(diffInSeconds);
};

export function diffSeconds(finish: Date, start: Date) {
  const asDayjs = dayjs(finish)
  let durationSeconds = asDayjs.diff(start, 'second')

  return durationSeconds
}

export const humanReadableTime = (time: string): string => {
  return time
    .replace(/\$\{hours\}/g, i18n.t('course.hours').toString())
    .replace(/\$\{hour\}/g, i18n.t('course.hour').toString())
    .replace(/\$\{minutes\}/g, i18n.t('course.minutes').toString())
    .replace(/\$\{minute\}/g, i18n.t('course.minute').toString());
};
